export const getOptionsData = (state) => state.options.optionsData;
